import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import { useNavigate } from "react-router-dom";
import DashboardsCards from "../../Components/DashboardCards/DashboardsCards";
import FavoriteCards from "./FavoriteCards";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";

const Favorites = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const [players, setPlayers] = useState([]);
  const [playersCount, setPlayersCount] = useState();
  const [isFiltered, setIsFiltered] = useState(false);
  const [open, setOpen] = useState(false);
  const [favoriteList, setFavoriteList] = useState([]);
  const userLoginDetails = getIsUser();
  const [activePricingTab, setActivePricingTab] = useState("fan");

  const handleNextClick = () => {
    setSkip((prevSkip) => prevSkip + 50);
  };
  const handleViewDetail = (player) => {
    navigate("/DetailsView", { state: { player } });
  };
  const listFavoritePlayers = (e) => {
    const url = `${APIUrl()}/v1/v1/list_favourite_players?userid=${
      userLoginDetails?.user_id
    }&favourite_type=${activePricingTab}&limit=50&skip=${e ? 0 : skip}`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        if (e) {
          setSkip(0);
          let data = response?.data?.data;
          setFavoriteList(data);
        } else {
          setFavoriteList((prev) => [...prev, response?.data?.data]);
        }
      })

      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  
  useEffect(() => {
    if (skip > 0) {
      listFavoritePlayers();
    } else {
      listFavoritePlayers(true);
    }
  }, [activePricingTab,skip]);

  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="content-section-changepass">
          <h3>Favorite Athletes</h3>
          <FavoriteCards
            handleViewDetail={handleViewDetail}
            playersCount={playersCount}
            players={favoriteList}
            loading={loading}
            setLoading={setLoading}
            handleNextClick={handleNextClick}
            open={open}
            setOpen={setOpen}
            listFavoritePlayers={listFavoritePlayers}
            activePricingTab={activePricingTab}
            setActivePricingTab={setActivePricingTab}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Favorites;
